module.exports = __webpack_public_path__ + "img/contact.e4288f52.jpg";